import { createAction } from '@reduxjs/toolkit';

interface GlobalThis {
  REDUX_STORE_VERSION?: string;
}

declare const globalThis: GlobalThis & typeof global;

// Lives here (not in store/index) so modules in the mboAPI require-cycle
// (baseApiWithReauth -> store -> mboApi -> baseApiWithReauth) can read the
// store version without importing the store module and re-entering the cycle.
export const getReduxStoreVersion = () => {
  try {
    return globalThis.REDUX_STORE_VERSION || 'root';
  } catch {
    return 'root';
  }
};

export const reset = createAction('RESET');

// Dispatched from shared logout code (baseApiWithReauth.logout()). Each target
// resolves the awaited promise by handling this action in its own middleware —
// mobile additionally awaits LucraSDK.logout(); web has no extra teardown.
export const triggerPlatformLogout = createAction(
  'TRIGGER_PLATFORM_LOGOUT',
  function prepare(onSuccess?: () => void) {
    return {
      payload: {
        onSuccess,
      },
    };
  }
);
